import { Button, Typography } from "@mui/material";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";

interface FinalCtaSectionProps {
  salesClosed: boolean;
  onCta: () => void;
}

export default function FinalCtaSection({ salesClosed, onCta }: FinalCtaSectionProps) {

  return (
    <section className="relative z-10 px-6 md:px-12 pb-20 md:pb-28 border-t border-white/10 pt-16 md:pt-20">
      <div className="flex flex-col items-center text-center max-w-2xl mx-auto">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#FF8904]/10 border border-[#FF8904]/30 text-[#FF8904] text-sm font-medium mb-8">
          <AutoAwesomeOutlinedIcon sx={{ fontSize: 16 }} />
          {salesClosed ? "Novas assinaturas encerradas" : "7 dias grátis · Cancele quando quiser"}
        </div>

        <Typography
          variant="h3"
          sx={{
            color: "#ffffff",
            fontWeight: 800,
            fontFamily: "Oxanium, sans-serif",
            letterSpacing: "-0.02em",
            lineHeight: 1.2,
            fontSize: { xs: "1.8rem", md: "2.4rem" },
            marginBottom: "20px",
          }}
        >
          Comece hoje mesmo a usar o{" "}
          <Typography
            component="span"
            sx={{
              fontWeight: 800,
              fontFamily: "Oxanium, sans-serif",
              fontSize: "inherit",
              lineHeight: "inherit",
              letterSpacing: "inherit",
              background: "linear-gradient(135deg, #FF8904 0%, #E7000B 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Dr. Weedy
          </Typography>
          .
        </Typography>

        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontSize: "1.05rem",
            lineHeight: 1.7,
            marginBottom: "36px",
          }}
        >
          Junte-se a médicos prescritores que já utilizam IA multiagente para
          tomar decisões clínicas com mais segurança e velocidade.
        </Typography>

        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Button
            onClick={onCta}
            variant="contained"
            sx={{
              background: "linear-gradient(135deg, #FF8904 0%, #E7000B 100%)",
              borderRadius: "24px",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 700,
              padding: "14px 36px",
              color: "#ffffff",
              boxShadow: "0 8px 24px rgba(255, 137, 4, 0.4)",
              "&:hover": {
                background: "linear-gradient(135deg, #E7000B 0%, #FF8904 100%)",
              },
            }}
          >
            {salesClosed ? "Entrar na lista de espera →" : "Começar teste gratuito →"}
          </Button>
          <Button
            component="a"
            href="mailto:weedy@saluton.clinic"
            variant="outlined"
            sx={{
              borderRadius: "24px",
              textTransform: "none",
              fontSize: "16px",
              fontWeight: 700,
              padding: "14px 32px",
              color: "#ffffff",
              borderColor: "rgba(255,255,255,0.25)",
              "&:hover": {
                borderColor: "#FF8904",
                backgroundColor: "rgba(255, 137, 4, 0.08)",
              },
            }}
          >
            Falar com especialista
          </Button>
        </div>
      </div>
    </section>
  );
}
